<!-- <p>
  leadquestionnaire works!
</p>
<p>{{leadDetails | json}}</p> -->
<div class="rk-ui-notification err" *ngIf="erroralert" style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert" style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>


<div class="container bg-white questionnaireContiner">
  <form [formGroup]="leadquestionnaireForm">
    <div class="row m-0" id="questionnaire-row">
      <div class="col-12 p-0 m-0">
        <div class="row">
          
          <div class="col-12 p-0 m-0">
            <div class="header">
              <span>Customer Details</span>
            </div>
          </div>
          
          <div class="col-sm-6 mt-4">
            <div class="">
              <label class="formCustomLabel">Customer Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control formControlInput" formControlName="customer_name">
            </div>
          </div>

          <div class="col-sm-6 mt-4" [ngClass]="{'d-none':role=='designer'}">
            <div class="">
              <label class="formCustomLabel">Customer Phone No<span class="text-danger">*</span></label>
              <input type="text" class="form-control formControlInput" formControlName="phone">
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <div class="">
              <label class="formCustomLabel">Pincode<span class="text-danger hideAsteriskIcon">*</span></label>
              <input type="number" class="form-control formControlInput" placeholder="Enter Pincode" formControlName="pincode">
            </div>
          </div>

          
          <div class="col-12 p-0 m-0">
            <div class="header mt-4">
              <span>Property Details</span>
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel"> Society Name/Building<span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="form-check" (mouseleave)="hideOptions()" (mouseenter)="showOptions()">
              <input type="text" class="form-control formControlInput" formControlName="society" placeholder="Type to search..."
                (keyup)="searchSocietyApi($event)">
              <ul class="adressSelect w-100"
                *ngIf="leadquestionnaireForm.controls['society'].value  !=''&& this.leadquestionnaireForm.controls['society'].value && isApifired">
                <li *ngFor="let option of filteredOptions " (click)="selectOption(option)"><span
                    class="d-inline-block h-100"><i class="fa fa-map-marker pr-1" aria-hidden="true" style="
                      font-size: 22px;vertical-align: middle; "></i></span> <span class="d-inline-block ml-1">{{
                    option.apartment_name }} {{ option.address }}</span>
                </li>
                <li *ngIf="!isSelected" class="w-100 d-flex align-items-center">
                  <div class="d-flex align-items-center justify-content-center h-100">
                    <i class="fa fa-map-marker pr-1" aria-hidden="true" style="
                                        font-size: 22px;vertical-align: middle; ">
                                        </i>
                                      </div>
                    <div class="d-flex align-items-center justify-content-between w-100 ml-1"> Could
                      not find your property? <br>
                      <button class="btn-pink px-3 py-2 mt-2" style="border-radius: 20px;border: solid;" (click)="selectOption('other')"> Add Property Details</button>
                    </div>
                </li>

              </ul>
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">City Name <span class="text-danger hideAsteriskIcon">*</span></label>
            <!-- <div class="form-check">
      
                  <ng-select formControlName="city" class="filterSelect dissplay-chng1" (change)="onchangeCity($event);onchangeCity2($event)">
      
                    <ng-option value="" disabled>Enter City Name</ng-option>
                    <ng-option *ngFor="let city of citiesForQuestionnaire" [value]="city.name">{{city.name | replaceChar}}
                    </ng-option>
                    <ng-option value="Others">Others</ng-option>
                  </ng-select>
      
                  <div class="form-check" [ngClass]="{'d-block':(this.cityChangeValue == 'Others')}">
                    <input type="text" id="citybuilding" formControlName="new_city_value" class="form-control formControlInput mt-3"
                      placeholder="Enter the City name">
                  </div>
                </div> -->
            <div class="form-check">
              <input type="text" readonly id="citybuilding" formControlName="city" class="form-control formControlInput"
                placeholder="Enter the City name">
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">Locality<span class="text-danger hideAsteriskIcon">*</span></label>

            <div id="localitybuilding" class="form-check">
              <input type="text" readonly formControlName="location" class="form-control formControlInput "
                placeholder="Enter the locality name">
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">Project Type<span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('project_type').value === 'Residential'}" >
                <input class="" type="radio" value="Residential" formControlName="project_type"
                  (change)="onChangeOfProjType($event)">
                  <label class="radioButtonLabel m-0 p-0">Residential</label>
              </label>
              <label class="radioBtnWrapper" [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('project_type').value === 'Offices'}" >
                <input class="" type="radio" value="Offices" formControlName="project_type"
                  (change)="onChangeOfProjType($event)">
                  <label class="radioButtonLabel m-0 p-0">Offices</label>
              </label>
            </div>
          </div>

          <div *ngIf="localityWebData && localityWebData.bhk.length>0" class="mt-4 data-web col-12">
            <div class="row">
              <h6 class="col-12">Data From Web</h6>
            </div>

            <div class="row">
              <div class="col-sm-3" style="padding-top:0.7rem;">
                <span data-toggle="modal" data-target="#floorplanModal" data-backdrop="static" data-keyboard="false"
                  style="color:#D05C17;cursor: pointer">{{localityWebData.society}}</span>
              </div>
              <div class="col-sm-9">
                <table class="table borderless table-design">
                  <thead>
                    <tr>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of localityWebData.bhk">
                      <td>{{data.type}}</td>
                      <td>{{data.area}} Sq Ft</td>
                      <td>{{data.price}}</td>
                      <td>{{data.possession || 'Ready to Move'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">Call Back Day <span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="form-check">
              <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter Date"
                formControlName="call_back_day" class="form-control formControlInput">
              <owl-date-time #dt1 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time>
            </div>
          </div>

          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">Call Back Time </label>
            <div class="form-check">
              <select formControlName="call_back_time" class="form-control formControlInput">
                <option value="" disabled>Choose</option>
                <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-6 mt-4">
            <div class="">
              <label class="text-left">Select Theme </label>
              <select formControlName="theme" class="form-control formControlInput capitalize">
                <option value="" disabled>Select</option>
                <option value="{{theme.id}}" *ngFor="let theme of themeList">{{theme.name}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-6 mt-4">
            <div class="">
              <label class="text-left">Select Life Stage <span class="text-danger hideAsteriskIcon">*</span></label>
              <select formControlName="lifestage" class="form-control formControlInput capitalize">
                <option value="" disabled>Select</option>
                <option value="{{stage.id}}" *ngFor="let stage of lifeStageList">{{stage.name | replaceChar}}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-12 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Type of Accommodation<span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('accomodation_type').value === at}" 
              *ngFor="let at of accommodation_type">
                <input class="" type="radio" value="{{at}}" formControlName="accomodation_type">
                <label class="radioButtonLabel m-0 p-0">{{at}}</label>
              </label>
            </div>
          </div>

          <div class="col-sm-12 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Type of Home <span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('home_type').value === hometype}" 
              *ngFor="let hometype of home_type_arr">
                <input class="" type="radio" value="{{hometype}}" formControlName="home_type">
                <label class="radioButtonLabel m-0 p-0">{{hometype}}</label>
              </label>
            </div>
          </div>

          <div class="col-sm-12 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Status of Property <span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('status_of_property').value === spo}"
                *ngFor="let spo of status_of_property_offices">
                <input type="radio" class="" value="{{spo}}" formControlName="status_of_property">
                <label class="radioButtonLabel m-0 p-0">{{spo}}</label>
              </label>
            </div>
          </div>

          <div class="col-sm-12 mt-4">
            <div class="">
              <label class="formCustomLabel">Purpose Of Property</label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                 [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('purpose_of_property').value === purpose}"
                  *ngFor="let purpose of purpose_of_property">
                  <input class="" type="radio" value="{{purpose}}"
                    formControlName="purpose_of_property">
                    <label class="radioButtonLabel m-0 p-0">{{purpose}}</label>
                </label>
              </div>
            </div>
          </div>

          <div class="col-sm-12 mt-4">
            <label class="formCustomLabel">Possession status<span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('possession_status').value === 'Possession Taken'}">
                <input class="" type="radio" value="Possession Taken"
                  formControlName="possession_status"
                  (click)="possesionStatusSelected('Possession Taken','updateQuestionnaire')">
                  <label class="radioButtonLabel m-0 p-0">Possession Taken</label>
                
              </label>
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('possession_status').value === 'Awaiting Possession'}">
                <input class="" type="radio" value="Awaiting Possession"
                  formControlName="possession_status"
                  (click)="possesionStatusSelected('Awaiting Possession','updateQuestionnaire')">
                  <label class="radioButtonLabel m-0 p-0">Awaiting Possession (If Yes, please fill the date of possession below on "other")</label>
                
              </label>
            </div>
          </div>

          <div class="col-sm-6 mt-4" id="possesiondateupdate"
            *ngIf="leadquestionnaireForm.controls['possession_status'].value=='Awaiting Possession'"
            (mouseleave)="taskChange()" (mouseenter)="taskChange()">
            <label class="formCustomLabel">Estimated month of Possession <span
                class="text-danger hideAsteriskIcon">*</span></label>
            <!-- <select formControlName="possession_status_date" class="form-control formControlInput">
                  <option value="" disabled>Choose</option>
                  <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                </select> -->
            <div class="form-check">
              <input name="startDate" id="startDate" class="bg-white form-control formControlInput date-picker" (focus)="callChangeNew()"
              formControlName="possession_status_date" placeholder="Choose A Month..." readonly="true" />
            </div>
          </div>

          <div class="col-sm-6 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Project Commencement Date <span
                class="text-danger hideAsteriskIcon">*</span></label>
            <div class="form-check">
              <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter Date"
                formControlName="project_commencement_date" class="form-control formControlInput">
              <owl-date-time #dt2 [pickerType]="'calendar'"></owl-date-time>
            </div>
          </div>

          <div class="col-sm-6 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Home Value(In Rs. Lacs)<span
                  class="hideAsteriskIcon text-danger">*</span></label>
              <select formControlName="home_value" class="form-control formControlInput">
                <option value="" disabled>Choose</option>
                <option value="Above 2.50 Cr"
                  selected="this.leadquestionnaireForm.controls['home_value'].value === 'Above 2.50 Cr'"
                  *ngIf="this.leadquestionnaireForm.controls['home_value'].value === 'Above 2.50 Cr'" disabled>Above
                  2.50
                  Cr</option>
                <ng-container *ngFor="let hv of home_value_arr">
                  <option value="{{hv}}">{{hv}}</option>
                </ng-container>
              </select>
            </div>
          </div>

          <div class="col-sm-6 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Budget Value(In Rs. Lacs)<span
                  class="hideAsteriskIcon text-danger">*</span></label>
              <select formControlName="budget_value" class="form-control formControlInput">
                <option value="" disabled>Choose</option>
                <option value="{{bvh}}" *ngFor="let bvh of budget_value_home">{{bvh}}</option>
              </select>
            </div>
          </div>

          <div class="col-sm-6 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Budget Value(In Rs. Lacs)<span
                  class="hideAsteriskIcon text-danger">*</span></label>
              <select formControlName="budget_value" class="form-control formControlInput">
                <option value="" disabled>Choose</option>
                <option value="{{bvh1}}" *ngFor="let bvh1 of budget_value_office">{{bvh1}}</option>
              </select>
            </div>
          </div>

          <div class="col-sm-12 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Type of Space<span class="text-danger hideAsteriskIcon">*</span></label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('type_of_space').value === tso}" 
                *ngFor="let tso of type_of_space_office">
                  <input class="" type="radio" value="{{tso}}" formControlName="type_of_space">
                  <label class="radioButtonLabel m-0 p-0">{{tso}}</label>
                </label>
              </div>
            </div>
          </div>

          <div class="col-sm-12 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Address of Site<span class="text-danger hideAsteriskIcon">*</span></label>
              <textarea formControlName="address_of_site" class="form-control formControlInput"></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Area of the Site (sq ft)<span
                  class="text-danger hideAsteriskIcon">*</span></label>
              <input type="number" name="" class="form-control formControlInput" min="0" formControlName="area_of_site">
            </div>
          </div>

          <div class="col-sm-6 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Residential')}">
            <div class="">
              <label class="formCustomLabel">Area of the Site (sq ft)<span
                  class="text-danger hideAsteriskIcon">*</span></label>
              <input type="number" name="" class="form-control formControlInput" min="0" formControlName="area_of_site">
            </div>
          </div>

          <div class="col-sm-6 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Layout and Photographs of Site<span
                  class="text-danger hideAsteriskIcon">*</span></label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('layout_and_photographs_of_site').value === 'Yes'}">
                  <input class="" type="radio" value="Yes"
                    formControlName="layout_and_photographs_of_site"> 
                    <label class="radioButtonLabel m-0 p-0">Yes</label>
                </label>
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('layout_and_photographs_of_site').value === 'No'}">
                  <input class="" type="radio" value="No"
                    formControlName="layout_and_photographs_of_site">
                    <label class="radioButtonLabel m-0 p-0">No</label>
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices' && leadquestionnaireForm.controls['layout_and_photographs_of_site'].value=='Yes')}">
            <label class="formCustomLabel">Upload Layouts and Photographs<span
                class="text-danger hideAsteriskIcon">*</span></label>
            <div class="form-check">
              <input type="file" name="layoutfiles" class="form-control formControlInput" multiple="multiple"
                id="fileupload" (change)="attachFile($event)">
            </div>
          </div>

          <div class="col-12 mt-4"
            *ngIf=" leadquestionnaireForm.controls['project_type'].value=='Offices' && leadquestionnaireForm.controls['layout_and_photographs_of_site'].value=='Yes' && userQuestionnaireDetails && userQuestionnaireDetails.length>0 && userQuestionnaireDetails[0].site_layouts && userQuestionnaireDetails[0].site_layouts.length>0">
            <label class="formCustomLabel">Uploaded Layouts and Photographs </label><br>
            <div class="form-check d-inline-block"
              *ngFor="let imgurl of userQuestionnaireDetails[0].site_layouts; let k1=index;">
              <a href="{{imgurl}}" target="_blank" style="color: #007bff" class="addCursor mr-3">Image{{k1+1}} </a>
            </div>
          </div>

          <!-- <div class="col-sm-6 mt-2">
       
                <div class="">
                 <label class="formCustomLabel">Lead Generator</label>
                  <select formControlName="lead_generator" class="form-control">
                    <option value="" disabled>Choose</option>
                    <option value="{{leadgen}}" *ngFor="let leadgen of lead_generator_arr">{{leadgen}}</option>
                  </select>
                </div>
       
              </div>
              <div class="col-sm-6 mt-2" style="display: none;">
       
              </div> -->
          <!-- <div class="col-sm-6 mt-2">
       
                <div class="">
                  <label class="formCustomLabel">Lead Source</label>
                  <select formControlName="lead_source" class="form-control">
                    <option value="" disabled>Choose</option>
                    <option value="{{leadsc}}" *ngFor="let leadsc of lead_source_questionnaire_arr">{{leadsc}}</option>
                  </select>
                </div>
              </div> -->

          <div class="col-12 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <div class="">
              <label class="formCustomLabel">Do you have a home loan against the property?<span
                  class="text-danger hideAsteriskIcon">*</span></label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('have_homeloan').value === haveloan}"
                  *ngFor="let haveloan of have_homeloan_arr">
                  <input class="" type="radio" value="{{haveloan}}" formControlName="have_homeloan">
                  <label class="radioButtonLabel m-0 p-0">{{haveloan}}</label>
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value && (leadquestionnaireForm.controls['project_type'].value=='Offices'||leadquestionnaireForm.controls['project_type'].value.length==0))}">
            <div class="">
              <label class="formCustomLabel">Do you have a floor plan?</label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('have_floorplan').value === 'Yes'}">
                  <input class="" type="radio" value="Yes" formControlName="have_floorplan"
                    (click)="fpQuestionnaireSelected('yes')">
                    <label class="radioButtonLabel m-0 p-0">Yes</label>
                  
                </label>
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('have_floorplan').value === 'No'}">
                  <input class="" type="radio" value="No" formControlName="have_floorplan"
                    (click)="fpQuestionnaireSelected('no')">
                    <label class="radioButtonLabel m-0 p-0">No</label>
                </label>
              </div>
            </div>
          </div>

          <div class="col-10 mt-4"
            *ngIf="leadquestionnaireForm.controls['lead_floorplan'].value != '/images/original/missing.png' && leadquestionnaireForm.controls['have_floorplan'].value=='Yes' && userQuestionnaireDetails && userQuestionnaireDetails.length!=0"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value && (leadquestionnaireForm.controls['project_type'].value=='Offices'||leadquestionnaireForm.controls['project_type'].value.length==0))}">
            <label class="formCustomLabel">Uploaded Floorplan</label>
            <div class="form-check">
              <a href="{{leadquestionnaireForm.controls['lead_floorplan'].value}}" target="_blank"
                style="color: #007bff">View Floorplan </a>
            </div>
          </div>

          <div class="col-12 mt-4"
            *ngIf="leadquestionnaireForm.controls['lead_floorplan'].value == '/images/original/missing.png' && leadquestionnaireForm.controls['have_floorplan'].value=='Yes' && userQuestionnaireDetails "
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value && (leadquestionnaireForm.controls['project_type'].value=='Offices'||leadquestionnaireForm.controls['project_type'].value.length==0))}">
            <label class="formCustomLabel">Uploaded Floorplan</label>
            <div class="form-check">
              <span class="text-danger">Floorplan Not Available</span>
            </div>
          </div>
          
          <div class="col-6 mt-4" id="floorplanQuestionnaire"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value && (leadquestionnaireForm.controls['project_type'].value=='Offices'||leadquestionnaireForm.controls['project_type'].value.length==0))}">
            <label class="formCustomLabel">Upload Floorplan</label>
            <div class="form-check">
              <input class="form-control formControlInput" type="file" (change)="onQuestionnaireFloorplanChange($event)"
                name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel"
                [ngModelOptions]="{standalone: true}" id="floorplanupload_input">
            </div>
            <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in proper
              image
              format).</p>
            <p class="col-sm-12 p-0 m-0 radioButtonLabel">Note* - Only Image, Doc and PDF files are allowed. </p>
          </div>

          <div class="col-12 p-0 mt-2 mx-0">
            <div class="header mt-4">
              <span>Scope Details</span>
            </div>
          </div>

          <div class="col-sm-12 mt-4"
            [ngClass]="{'d-none':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Scope of work <span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('scope_of_work').value === sw}"
               *ngFor="let sw of scopeOfwork_home">
                <input type="radio" class="" value="{{sw}}" formControlName="scope_of_work">
                <label class="radioButtonLabel m-0 p-0">{{sw}}</label>
              </label>
            </div>
          </div>

          <div class="col-sm-12 mt-4 d-none"
            [ngClass]="{'d-block':(leadquestionnaireForm.controls['project_type'].value=='Offices')}">
            <label class="formCustomLabel">Scope of work <span class="text-danger hideAsteriskIcon">*</span></label>
            <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
              <label class="radioBtnWrapper" 
              [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('scope_of_work').value === sw1}" 
              *ngFor="let sw1 of scopeOfwork_office">
                <input type="radio" class="" value="{{sw1}}" formControlName="scope_of_work">
                <label class="radioButtonLabel m-0 p-0">{{sw1}}</label>
              </label>
            </div>
          </div>

          <div class="budget-calculator col-12 mt-4 mx-0">
            <label class="budgetCalculatorLabel">Scope of Work/Budget Calculator</label><br>
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-6">
                    <label class="formCustomLabel mt-2">Item</label>
                    <input type="text" (keyup)="searchquestionarrieItem($event)" [(ngModel)]="searchname" name="searchname"
                      [ngModelOptions]="{standalone: true}" autocomplete="off" class="form-control formControlInput "
                      placeholder="Search By Name">
                    <label [ngClass]="{'d-none':(this.searchstatus == 'false')}" class="w-100 mt-3 alert alert-danger"
                      id="notfound">Item not found, Please add custom item.<span>
                        <i style="font-size:14px" class="fa fa-remove color-crimson2 addCursor float-right" (click)="hide()"></i>
                      </span></label>
                  </div>
                  <div class="col-6 align-content-end">
                    <div class="d-flex align-items-center gap-10 mt-3 pt-1">
                      <button (click)="showAddOtherItem()" id="addMoreLeadItemBtn"
                      class="btn submitBtnStyle w-50 h-100 form-control  color-crimson float-right addCursor">+ Add new</button>
                      <input type="text" placeholder="Enter the custom item" id="otherLeadItem"
                        class="form-control formControlInput hide" name="name">
                      <button (click)="SaveOtherLeadItem($event)" id="submitOtherLeadBtn"
                        class="btn submitBtnStyle h-100 form-control color-crimson hide addCursor">Add Custom Item</button>
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <ul *ngIf="searchList" class="ks-cboxtags mb-0 d-flex align-items-center flex-wrap" id="myUL">
                    <li *ngFor="let item of searchList.slice(0,10);let i = index">
                      <span *ngIf="leadItemscheckedListNames.includes(item.name.toLowerCase())">
                        <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                          (change)="isAllSelected($event)" value="{{item.name}}" checked>
                        <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                      </span>
                      <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                        <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                          (change)="isAllSelected($event)" value="{{item.name}}">
                        <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                      </span>
                    </li>
                    <li data-toggle="tooltip" title="Search for additional items." *ngIf="searchList.length>10">
                      <span>
                        <input onclick="return false;" type="checkbox" id="more" value="More...">
                        <label for="more">More...</label>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
          
              <div class="col-sm-12 mt-0" *ngIf="checkedList.length > 0">
                <div class="row mt-2 p-0" *ngFor="let budgetdata of checkedList" cellspacing="10">
                  <div class="col-12 d-flex align-items-center justify-content-end">
                    <i style="font-size:15px;color: #922230;" class="fa addCursor" (click)="removequestionaireitesm(budgetdata)">&#xf00d;</i>
                  </div>
                  <div class="col-3">
                    <label class="formCustomLabel">Name</label>
                    <div><input type="text" class="form-control formControlInput" value="{{budgetdata.name}}" readonly /></div>
                  </div>
                  <div class="col-3">
                    <label class="formCustomLabel">Price</label>
                    <div>
                      <input type="text" class="form-control formControlInput" value="{{budgetdata.price}}" readonly />
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="formCustomLabel">Quantity</label>
                    <div>
                      <input type="number" min="1" class="form-control formControlInput text-center"
                      value="{{budgetdata.quantity}}" (change)="valuechange(budgetdata)" [(ngModel)]="budgetdata.quantity"
                      [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="formCustomLabel">Total</label>
                    <div>
                      <input type="text" class="form-control formControlInput text-center"
                        value="{{budgetdata.quantity * budgetdata.price}}" readonly />
                    </div>
                  </div>
                </div>

                <!-- <table *ngIf="checkedList.length > 0 && false" class="mt-3 w-100">
                  <tr>
                    <th class="text-center text-design">Name</th>
                    <th class="text-center text-design">Price</th>
                    <th class="text-center text-design">Quantity</th>
                    <th class="text-center text-design">Total</th>
                    <th class="text-center text-design"></th>
                  </tr>
                  <tr class="input-design" *ngFor="let budgetdata of checkedList" cellspacing="10">
                    <td><input type="text" class="form-control formControlInput" value="{{budgetdata.name}}" readonly /></td>
                    <td>
                      <input type="text" class="form-control formControlInput" value="{{budgetdata.price}}" readonly />
                    </td>
                    <td>
                      <input type="number" min="1" class="form-control formControlInput text-center"
                        value="{{budgetdata.quantity}}" (change)="valuechange(budgetdata)" [(ngModel)]="budgetdata.quantity"
                        [ngModelOptions]="{standalone: true}">
                    </td>
                    <td>
                      <input type="text" class="form-control formControlInput text-center"
                        value="{{budgetdata.quantity * budgetdata.price}}" readonly />
                    </td>
                    <td>
                      <i style="font-size:15px" class="fa addCursor" (click)="removequestionaireitesm(budgetdata)">&#xf00d;</i>
                    </td>
                  </tr>
                </table> -->

                <div class="d-flex align-items-center mt-3 justify-content-end">
                  <p style="text-align: end" *ngIf="checkedList.length > 0">Total: <i class="fas fa-rupee-sign total-cost-text"></i>
                    {{this.totalBudget}}</p>
                </div>
              </div>
            </div>
          
          </div>
        </div>

        <div class="row" (mouseleave)="workChange()" (mouseenter)="workChange()">
          <div class="col-sm-6 mt-4">
            <label class="formCustomLabel">When would you like us to start work?<span
                class="text-danger hideAsteriskIcon">*</span></label>
            <div>
              <input name="startDateNewpro" class="form-control formControlInput" id="startDateNewpro" (focus)="DateForWorkStart()"
              formControlName="intended_date" placeholder="Choose A Month..." readonly="true" />
            </div>
          </div>

          <div class="col-sm-6 mt-4"></div>
          <!-- <div class="col-sm-6 mt-2" >
                  <label class="formCustomLabel">When would you like us to start work?<span class="text-danger hideAsteriskIcon">*</span></label>
                  <div class="form-check">
                    <input [owlDateTime]="dt5" [owlDateTimeTrigger]="dt5" placeholder="Enter Date" formControlName="intended_date" class="form-control formControlInput" (dateTimeChange)="onChange($event)">
                    <owl-date-time #dt5 [pickerType]="'calendar'" ></owl-date-time> 
                  </div>
                </div> -->
          
          <div class="col-sm-6 mt-4">
            <div class="">
              <label class="formCustomLabel">Would you like to visit our EC ?</label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('visit_ec').value === true}">
                  <input class="" type="radio" [value]="true" formControlName="visit_ec"
                    (click)="ec(true)">
                    <label class="radioButtonLabel m-0 p-0">Yes</label>
                </label>
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('visit_ec').value === false}">
                  <input class="" type="radio" [value]="false" formControlName="visit_ec"
                    (click)="ec(false)">
                    <label class="radioButtonLabel m-0 p-0">No</label>
                </label>
              </div>
            </div>
          </div>

          <ng-container *ngIf="this.selectstatus">
            <div class="col-sm-6 mt-4">
              <div class="form-check">
                <!-- <input id="dt6" [min]="selectedMoment" [owlDateTime]="dt6" [owlDateTimeTrigger]="dt6" placeholder="Enter Date ( Date should be greater than current date )" formControlName="visit_ec_date" class="form-control formControlInput"> -->
                <input id="dt6" [owlDateTime]="dt6" [owlDateTimeTrigger]="dt6"
                  placeholder="Enter Date ( Date should be greater than the current date )"
                  formControlName="visit_ec_date" class="form-control formControlInput">
                <owl-date-time #dt6 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time>
              </div>
            </div>
          </ng-container>

          <div class="col-sm-6 mt-4">
            <div class="">
              <label class="formCustomLabel">Do you need Site Measurement ?</label>
              <div class="d-flex align-items-center gap-10 flex-wrap mt-2">
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('site_measurement_required').value === true}">
                  <input class="" type="radio" [value]="true"
                    formControlName="site_measurement_required" (click)="sitemeasurement(true)">
                    <label class="radioButtonLabel m-0 p-0">Yes</label>
                </label>
                <label class="radioBtnWrapper" 
                [ngClass]="{'radioBtnWrapperBorder': leadquestionnaireForm.get('site_measurement_required').value === false}">
                  <input class="" type="radio" [value]="false"
                    formControlName="site_measurement_required" (click)="sitemeasurement(false)">
                    <label class="radioButtonLabel m-0 p-0">No</label>
                </label>
              </div>
            </div>
          </div>


          <ng-container *ngIf="this.selectstatusforsite">
            <div class="col-sm-6 mt-4">
              <div class="form-check">
                <!-- <input id="mes" [min]="selectedMoment" [owlDateTime]="mes" [owlDateTimeTrigger]="mes" placeholder="Enter Date (Date should be greater than current date)" formControlName="site_measurement_date" class="form-control formControlInput"> -->
                <input id="mes" [owlDateTime]="mes" [owlDateTimeTrigger]="mes"
                  placeholder="Enter Date ( Date should be greater than the current date )"
                  formControlName="site_measurement_date" class="form-control formControlInput">
                <owl-date-time #mes [pickerType]="'calendar'"></owl-date-time>
              </div>
            </div>
            <div class="col-sm-6 mt-2"></div>
          </ng-container>
        </div>

        <!-- <div class="col-sm-6 mt-2">
                  <div class="">
                    <label class="formCustomLabel">When is a good time for our designer to call ?</label>
                    <div class="form-check">
                      <label style="width:100%" class="lableSize labelColor mb-2 mr-4">
                        <input id="designer_call" [min]="selectedMoment" [owlDateTime]="designer_call" [owlDateTimeTrigger]="designer_call" placeholder="Enter Date (Date should be greater than current date)" formControlName="good_time_to_call" class="form-control">
                        
                        <owl-date-time #designer_call [pickerType]="'both'" [startView]="'month'"></owl-date-time> 
                      </label>
                    </div>
                  </div>
              </div> -->

        <div class="row">
          <div class="col-12 mt-4"
            *ngIf="!((role=='designer') && (path == '/lead/'+leadId+'/detailed-info'))">
            <div class="col-md-12 p-0 m-0 d-flex align-items-center justify-content-between">
              <label style="display:block" class="formCustomLabel">Any Alternate Contact ?</label>
              <button type="button" class="btn btn-pink addCursor btnnumber" *ngIf="!hideAlternateNumberButton"
                (click)="addAlternateNumberForm()">Add Alternate Number</button>
              <span class="font-weight-bold ml-0 pl-0" *ngIf="hideAlternateNumberButton">Alternate Number:</span>
            </div>

            <div *ngIf="showAlternateForm">
              <form [formGroup]="alternateNumberMasterForm">
                <div formArrayName="alternate_contacts" class="mt-3"
                  *ngFor="let item of alternateNumberMasterForm.get('alternate_contacts')['controls']; let i = index;">
                  <div class="row" [formGroupName]="i">
                    
                      <div class="col-12 m-0">
                        <label class="alternateNumberLabel">Alternate Number: {{i+1}}</label>
                        <span class="pull-right addCursor d-block" (click)="removeAlternateNumber(i)">
                          <i style="color: #922230;" class="fa fa-minus-circle minus-icon"></i>
                        </span>
                      </div>
                      <div class="col-4 m-0">
                        <label class="formCustomLabel">Name </label> 
                        <input
                          class="form-control formControlInput" type="text" formControlName="name"
                          placeholder="Name">
                      </div>
                      <div class="col-4 m-0">
                        <label class="formCustomLabel">Relation</label> <input
                          class="form-control formControlInput" type="text" formControlName="relation"
                          placeholder="Relation">
                      </div>
                      <div class="col-4 m-0">
                        <label class="formCustomLabel">
                          Contact
                        </label>
                        <input class="form-control formControlInput" type="text" formControlName="contact"
                          placeholder="Contact">
                      </div>
                    
                  </div>
                  <br>
                </div>
              </form>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 mt-4">
            <div class="">
              <label class="formCustomLabel">Additional Comments</label>
              <div class="form-check">
                <textarea rows="8" class="form-control formControlInput" formControlName="additional_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 mt-4" [ngClass]="{'d-none':(role!='community_manager' && role
              !='designer')}">
            <div class="">
              <label class="formCustomLabel">CM Comments</label>
              <div class="form-check">
                <textarea rows="2" class="form-control formControlInput" formControlName="cm_comments"></textarea>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 mt-4" [ngClass]="{'d-none':(role!='community_manager' && role
              !='designer')}">
            <div class="">
              <label class="formCustomLabel">Designer Comments</label>
              <div class="form-check">
                <textarea rows="2" class="form-control formControlInput" formControlName="designer_comments"></textarea>
              </div>
            </div>
          </div>

          <ng-container *ngIf="( role
                =='cs_agent')">
            <!-- //V:It will show when Awaiting Possession selected and intended date not selected // -->
            <div class="col-md-6 p-0"
              *ngIf="this.leadquestionnaireForm.controls['possession_status'].value=='Awaiting Possession'"
              style="min-width: 100%">
              <div class="col-md-6 p-0" *ngIf="this.leadquestionnaireForm.controls['intended_date'].value==''"
                style="min-width: 100%">
                <div class="col-sm-6 col-md-6 mt-2" id="normalStat">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="qualified">Qualified</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 mt-2 d-none" id="delyed">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="">Select Status</option>
                      <option value="delayed_possession">Delayed Possession</option>
                      <!--  <option value="delayed_project">Delayed Project</option> -->
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- //V:It will show when Awaiting Possession not selected and intended date selected // -->
            <div class="col-md-6 p-0" *ngIf="this.leadquestionnaireForm.controls['intended_date'].value
                !=''" style="min-width: 100%">
              <div class="col-md-6 p-0"
                *ngIf="this.leadquestionnaireForm.controls['possession_status'].value !='Awaiting Possession'"
                style="min-width: 100%">
                <div class="col-sm-6 col-md-6 mt-2" id="normalStat1">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="qualified">Qualified</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 mt-2 d-none" id="delyed1">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="">Select Status</option>
                      <option value="delayed_project">Delayed Project</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- //V:It will show when Awaiting Possession selected and intended date selected (both selected)// -->
            <div class="col-md-6 p-0" *ngIf="this.leadquestionnaireForm.controls['intended_date'].value
                !=''" style="min-width: 100%">
              <div class="col-md-6 p-0"
                *ngIf="this.leadquestionnaireForm.controls['possession_status'].value =='Awaiting Possession'"
                style="min-width: 100%">
                <div class="col-sm-6 col-md-6 mt-2" id="normalStat1">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="qualified">Qualified</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="lost">Lost</option>
                      <option value="not_contactable">Not Contactable</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 mt-2 d-none" id="delyed1">
                  <div class="">
                    <label class="formCustomLabel">Change Status</label>
                    <select class="form-control formControlInput" formControlName="lead_status"
                      (change)="setLeadStatus2($event.target.value)">
                      <option value="">Select Status</option>
                      <option value="delayed_possession">Delayed Possession</option>
                      <option value="delayed_project">Delayed Project</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- //V:It will show when Awaiting Possession  and intended date both not selected// -->
            <div class="col-md-6 p-0" *ngIf="this.leadquestionnaireForm.controls['intended_date'].value==''"
              style="min-width: 100%">
              <div class="col-md-6 p-0"
                *ngIf="this.leadquestionnaireForm.controls['possession_status'].value !='Awaiting Possession'"
                style="min-width: 100%">
                <div class="col-md-6" id="normalStat2">
                  <label>Change Status</label>
                  <select class="form-control formControlInput" (change)="setLeadStatus($event.target.value)"
                    formControlName="lead_status" id="chnagestatusDropDown">
                    <option value="" disabled>Select Status</option>
                    <option value="qualified">Qualified</option>
                    <option value="follow_up">Follow Up</option>
                    <option value="lost">Lost</option>
                    <option value="not_contactable">Not Contactable</option>
                  </select>
                </div>
              </div>
            </div>
            <!--  V:end here -->
            <div class="col-sm-6 col-md-6 mt-2 d-none"
              [ngClass]="{'d-block':(leadquestionnaireForm.controls['lead_status'].value=='follow_up')}">
              <div class="">
                <label class="formCustomLabel">Followup Time <span class="text-danger">*</span></label>
                <input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" placeholder="Enter Date and Time"
                  formControlName="follow_up_time" class="form-control formControlInput">
                <owl-date-time #dt3></owl-date-time>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 mt-2 d-none"
              [ngClass]="{'d-block':(leadquestionnaireForm.controls['lead_status'].value=='follow_up')}">
              <div class="">
                <label class="formCustomLabel">Followup Remark <span class="text-danger">*</span></label>
                <input class="form-control formControlInput" type="text" formControlName="remark">
              </div>
            </div>
            <div class="col-sm-6 col-md-6 mt-2 d-none"
              [ngClass]="{'d-block':(leadquestionnaireForm.controls['lead_status'].value=='lost')}">
              <div class="">
                <label class="formCustomLabel">Reason for Lost<span class="text-danger">*</span></label>
                <select class="form-control formControlInput" id="lost_reason" formControlName="lost_reason"
                  (change)="reasonForLostDropdownChange1($event.target.value)">
                  <option value="" disabled>Select Reason</option>
                  <option *ngFor="let reason of lostReasonsArr" value="{{reason}}">{{reason | replaceChar}}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 mt-2 d-none" id="addleadFormlostremark"
              [ngClass]="{'d-block':(leadquestionnaireForm.controls['lead_status'].value=='lost' ) && (lostReasonsArr.indexOf(leadquestionnaireForm.controls['lost_reason'].value) > -1)}">
              <div class="" *ngIf="leadquestionnaireForm.controls['lead_status'].value=='lost'">
                <label class="formCustomLabel">Remarks <span class="text-danger">*</span></label>
                <textarea class="form-control formControlInput" rows="2" formControlName="lost_remark"></textarea>
              </div>
            </div>
          </ng-container>
          <div class="col-sm-12 col-md-12 mb-3">
            <button class="btn submitBtnStyle bg-secondary cancle ml-3 mt-3 pull-right addCursor rk-btnCancel" data-dismiss="modal" aria-label="Close"
              (click)="userQuestionnaireDetails=undefined; closeModal();this.localityWebData=null; "
              [ngClass]="{'d-none':(role=='community_manager' || role =='designer')}">Cancel</button>

            <button
              [disabled]="leadquestionnaireForm.invalid  || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['location'].value=='Others' && (!leadquestionnaireForm.controls['new_locality_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['society'].value=='Others' && (!leadquestionnaireForm.controls['new_society_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['city'].value=='Others' && (!leadquestionnaireForm.controls['new_city_value'].value)) "
              class="btn ml-3 mt-3 submitBtnStyle pull-right addCursor" type="submit"
              *ngIf="userQuestionnaireDetails && userQuestionnaireDetails.length >0"
              (click)="updateRecordNotesQuestionnaire(_leadDetails.id,leadquestionnaireForm.value);">Update</button>

            <button class="btn submitBtnStyle pull-right addCursor mt-3 am-chng d-none" type="submit"
              [disabled]="leadquestionnaireForm.invalid  || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['location'].value=='Others' && (!leadquestionnaireForm.controls['new_locality_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['society'].value=='Others' && (!leadquestionnaireForm.controls['new_society_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['city'].value=='Others' && (!leadquestionnaireForm.controls['new_city_value'].value)) "
              *ngIf="userQuestionnaireDetails && userQuestionnaireDetails.length ==0 "
              (click)="updateRecordNotesQuestionnaire(_leadDetails.id,leadquestionnaireForm.value);"
              [ngClass]="{'d-block':role!='cs_agent'}">Submit</button>

            <button class="btn submitBtnStyle pull-right addCursor mt-3 am-chng d-none" type="submit"
              [disabled]="leadquestionnaireForm.invalid  || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['location'].value=='Others' && (!leadquestionnaireForm.controls['new_locality_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['society'].value=='Others' && (!leadquestionnaireForm.controls['new_society_value'].value)) || (leadquestionnaireForm.valid && leadquestionnaireForm.controls['city'].value=='Others' && (!leadquestionnaireForm.controls['new_city_value'].value)) "
              *ngIf="userQuestionnaireDetails && userQuestionnaireDetails.length ==0 "
              (click)="addLeadQuestionnaire(leadquestionnaireForm.value);"
              [ngClass]="{'d-block':(role=='cs_agent' && _leadDetails && _leadDetails['questionnaire_type']=='add_lead')}">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>


<div id="floorplanModal" class="modal" role="dialog">
  <div class="modal-dialog floorplan-positionn">
    <!-- Modal content-->
    <div style="margin-top:100%;border: 3px solid #6F0000;" class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">List of floorplans present:</h6>
        <button (click)="closeFloorplanModal()" type="button" class="close"><i class="fa fa-close"></i></button>
      </div>
      <div class="modal-body floorplan-design">
        <table *ngIf="localityWebData" class="table">
          <thead>
            <tr>
              <th style="text-align:center">#</th>
              <th style="text-align:center">Floorplan</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let floorplan of localityWebData.floorplan;let i=index">
              <td style="text-align:center">{{i+1}}</td>
              <td style="text-align:center;"><a style="color:#6F0000;" href="{{floorplan}}" target="_blank"
                  download>Floorplan-{{i+1}}</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div id="OtherProjectname" class="modal" role="dialog" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="TabQuestionire?'':'leadQUES'"
    style="max-width: 50rem !important;">
    <!-- Modal content-->
    <div style="border: 3px solid #6F0000;" class="modal-content p-1">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center"> Add Society/Building/Project</h6>
        <button (click)="closeaddApartmentrplanModal()" type="button" class="close"><i class="fa fa-close"></i></button>


      </div>
      <div class="modal-body " (mouseover)="pincodeval()">
        <div class="col-12 row">
          <div class="form-check d-flex col-12 ">
            <label class="formCustomLabel mt-2 col-6">Society/Building/Project Name :<span
                class="text-danger hideAsteriskIcon">*</span></label>
            <input type="text" class="form-control formControlInput col-6" [(ngModel)]="projectName"
              placeholder="Enter the Project name">
          </div>
          <div class="form-check  d-flex col-12">
            <label class="formCustomLabel mt-2 col-6 ">Developer Name :<span
                class="text-danger hideAsteriskIcon">*</span></label>
            <input type="text" class="form-control formControlInput col-6" placeholder="Enter the Developer name"
              [(ngModel)]="DeveloperName">
          </div>
          <div class="form-check d-flex col-12">
            <label class="formCustomLabel mt-2  col-6">Full Address :<span
                class="text-danger hideAsteriskIcon">*</span></label>
            <input id="autocomplete-input" type="text" class="form-control formControlInput" [(ngModel)]="FullAdress"
              (focus)="pincodeval()" (change)="pincodeval()" placeholder="Enter the Full Address">

          </div>
          <div class="form-check  d-flex col-12">
            <label class="formCustomLabel mt-2 col-6">City :<span class="text-danger ">*</span></label>
            <input id="citygoogle" readonly type="text" class="form-control formControlInput col-6">
          </div>

          <div class="form-check d-flex col-12">
            <label class="formCustomLabel mt-2 col-6">Pincode :<span class="text-danger ">*</span></label>
            <input id="pincodegoogle" type="text" [(ngModel)]="pincodePro" class="form-control formControlInput col-6">
            <input id="areaname" readonly type="text" class="form-control formControlInput d-none col-6">
          </div>
        </div>
        <div class="col-12 mt-2 d-flex justify-content-center">

          <button class="btn btn-pink px-3 py-2"
            [disabled]="projectName == '' || DeveloperName == '' ||  FullAdress == '' || pincodePro == ''  "
            (click)="Submitapart()">Submit</button>

        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/leadquestionnaire/leadquestionnaire.component.html